// 外觀模塊
export default {
    Appearance: {
        MobilePhone: '手機',
        Computer: '電腦',
        AppearanceSettings: '外觀設置',
        Header: '頁眉',
        ShowHeader: '顯示頁眉',
        HeaderType: '頁眉類型',
        Writing: '文字',
        Single: '單圖',
        TextContent: '文字內容',
        PleaseEnterContent: '請輸入內容',
        FontSettings: '字體設置',
        Align: '對齊方式',
        LeftJustifying: '左對齊',
        Center: '居中',
        RightAlignment: '右對齊',
        bgColor: '背景顏色',
        HeaderImage: '頁眉圖片',
        AddPicture: '添加圖片',
        Background: '背景',
        BackgroundSettings: '背景設置',
        Pictures: '上傳圖片',
        ChooseAColor: '選擇顏色',
        BackgroundImage: '背景圖片',
        BackgroundPosition: '背景位置',
        Tile: '平鋪',
        BackgroundTransparency: '底色透明度',
        LogoSettings: 'logo設置',
        LogoLocation: 'logo位置',
        ProjectTitle: '項目標題',
        WelcomeMessage: '歡迎語',
        Stem: '題幹',
        Option: '選項',
        Conclusion: '結束語',
        ButtonSettings: '按鈕設置',
        SubmitButtonText: '提交按鈕文字',
        DisplaySettings: '顯示設置',
        ShowHeading: '顯示標題',
        ShowWelcomeMessage: '顯示歡迎語',
        DisplayQuestionNumber: '顯示題目序號',
        SubmitTo: '提交'
    },
  };